import { AxiosInstance } from 'axios';
import { QueryStringBuilder } from '../helpers';
import { EmailMessageType, ISendOutMessage, IVoterSendOutRequest } from '../models';

export class SendOutsClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/sendOuts`;
    }

    public async getMessage(prefix: string,
                            id: string,
                            type: EmailMessageType,
                            includeLayoutTemplate = false): Promise<ISendOutMessage> {

        const url = new QueryStringBuilder()
            .withQueryIfNotEmpty('includeLayoutTemplate', includeLayoutTemplate)
            .build(`${this.apiUrl}/${prefix}/${id}/message/${type}`);

        const response = await this.axiosClient.get(
            url,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }
        );

        return response.data;

    }

    public async send(prefix: string, id: string, request: IVoterSendOutRequest): Promise<void> {

        const url = new QueryStringBuilder()
            .build(`${this.apiUrl}/${prefix}/${id}`);

        const response = await this.axiosClient.post(
            url,
            request,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }
        );

        return response.data;
    }

}
